import { BASE_URL, API_ENDPOINTS } from '../config/api.config';

/**
 * Fetch a CSV export from the backend and trigger a browser download.
 * @param {'all'|'nonprofit'|'pin'} type
 */
export async function downloadUsersCsv(type) {
  const token = localStorage.getItem('accessToken');
  const url = `${BASE_URL}${API_ENDPOINTS.EXPORT_USERS(type)}`;

  const response = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    throw new Error(`Export failed (${response.status})`);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;

  // Use filename from Content-Disposition if available, else fallback
  const disposition = response.headers.get('Content-Disposition') || '';
  const match = disposition.match(/filename="([^"]+)"/);
  link.download = match ? match[1] : `${type}-users.csv`;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
}
